import React from "react";
import { ForgeObjectDto, ProjectDto } from "../../../api/APIClient";

// We use this 'hacky' way because it needs to be declared with default values
// But we are sure that the value passed to the context is always the Dto
export const ProjectContext = React.createContext<ProjectDto>({} as ProjectDto);
export const ProjectModelContext = React.createContext<ForgeObjectDto>({} as ForgeObjectDto);
export const SidePanelStatusContext = React.createContext<boolean>(true);
